module.exports = __webpack_public_path__ + "static/media/cagdas_profile.017ad673.jpg";